// 3rd-party modules
import { useEffect, useState } from "react";

// project modules
import { apiCall } from "../../helpers/apiHelper";
import CustomChart from "../shared/chart/chart";

//apis
import * as ReportApi from '../../apis/reportApi';
import Loader from "../shared/loader";
import useTranslation from "../../hooks/TranslationContext";
import { Radio, RadioChangeEvent, Typography } from "antd";
import { SellItemSummeryReportModel } from "../../models/sellItemSummeryReport";

const TOP_ITEMS_COUNT = 15;
export default function SellServiceItemSummeryReport() {
  const { t } = useTranslation();

  const [period, setPeriod] = useState<number>(7);
  const [loading, setLoading] = useState(false);
  const [datasource, setDatasource] = useState<any[]>([]);
  const abortController = new AbortController();

  const chartOptions = {
    chart: {
      type: "pie",
    },
    labels: datasource.map((item) => item.name || "-"),
    tooltip: {
      y: {
        formatter: (val: number) => `${val} ${t("count")}`,
      },
    },
    legend: {
      position: "left",
    },
  };

  useEffect(() => {
    getDataAsync();
  }, [period]);

  const getData = async (abortSignal?: AbortSignal) => {
    const response = await apiCall(ReportApi.getSellServiceItemSummeryReport(period, abortSignal));

    const data = response.success ? SellItemSummeryReportModel.toArrayOfClass((response.data?.value || [])) : [];

    let returnValue = data;

    if (data.length && data.length > TOP_ITEMS_COUNT) {
      const topItems = data.slice(0, TOP_ITEMS_COUNT);
      const otherItemsCount = data.slice(TOP_ITEMS_COUNT).reduce((sum, item) => sum + (item.count || 0), 0);

      returnValue = [
        ...topItems,
        { name: t('other'), count: otherItemsCount }
      ];
    }

    return returnValue;
  };

  const getDataAsync = async () => {
    setLoading(true);
    setDatasource(await getData(abortController.signal));
    setLoading(false);
  }

  const onPeriodChange = (e: RadioChangeEvent) => {
    setPeriod(e.target.value)
  };

  return (
    <>
      <Typography.Text strong>{t("sell-service-item-summery-report")}</Typography.Text>
      <div className="">
        <Radio.Group onChange={onPeriodChange} defaultValue="7">
          <Radio.Button value="1">1</Radio.Button>
          <Radio.Button value="3">3</Radio.Button>
          <Radio.Button value="7">7</Radio.Button>
          <Radio.Button value="30">30</Radio.Button>
          <Radio.Button value="90">90</Radio.Button>
        </Radio.Group>
      </div>
      {loading && <Loader />}
      {!loading &&
        <CustomChart
          options={chartOptions}
          series={datasource.map((item) => item.count || 0)}
          type="pie"
          height={250}
          width="100%"
        />}
    </>
  )
}
